import { displayCurrency, displayDate } from '@/utils/format.utils';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';
import type { ModelOrderResponse } from '@layup/api-sdk';

export const boostRewardsTableColumns: ColumnDef<ModelOrderResponse>[] = [
  {
    accessorKey: 'orderReference',
    header: 'Order Reference',
    cell: ({ getValue }) => {
      const reference = getValue() as string;
      return h('div', reference);
    },
  },
  {
    accessorKey: 'completedAt',
    header: 'Completed At',
    cell: ({ getValue }) => {
      const dateUpdated = getValue() as string;
      return h('div', displayDate(dateUpdated));
    },
  },
  {
    accessorKey: 'voucherCode',
    header: 'Voucher Code',
    cell: ({ getValue }) => {
      const voucherCode = getValue() as string;
      return h('div', `...${voucherCode}`);
    },
  },
  {
    accessorKey: 'voucherTotal',
    header: () => h('div', { class: 'text-right' }, 'Voucher Total'),
    cell: ({ getValue }) => {
      const amount = getValue() as number;
      const displayAmount = displayCurrency(amount);
      return h('div', { class: 'text-right' }, displayAmount);
    },
  },
];
